import { render, staticRenderFns } from "./MarketingEmailEditRecipients.vue?vue&type=template&id=6d3a8de7&scoped=true"
import script from "./MarketingEmailEditRecipients.vue?vue&type=script&lang=js"
export * from "./MarketingEmailEditRecipients.vue?vue&type=script&lang=js"
import style0 from "./MarketingEmailEditRecipients.vue?vue&type=style&index=0&id=6d3a8de7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3a8de7",
  null
  
)

export default component.exports